// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__BfHC7","skeleton-loading":"Skeleton_skeleton-loading__qqR6Y"};